import React, { useState } from "react";

const ChooseLoanType = ({
  isChooseLoanTypeOpen,
  closeChooseLoanType,
  handleEligibilityCheck,
}) => {
  const [selectedAccount, setSelectedAccount] = useState("Flash Loan");

  if (!isChooseLoanTypeOpen) return null;

  return (
    <>
      <div
        className={`${
          isChooseLoanTypeOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-10 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative bg-white shadow w-[600px] md:w-[750px] h-[70vh] mx-auto p-6 rounded-sm flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={closeChooseLoanType}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ✕
              </button>
            </div>

            <div className="mt-6 flex flex-col h-full">
              <h2 className="text-2xl font-bold text-black mb-4 text-center flex justify-start">
                Create Account
              </h2>

              <p className="text-black mb-6">
                Choose the account you’d like to create for the member.
              </p>

              <div className="flex justify-center items-center flex-grow">
                <div className="flex flex-col items-start space-y-4">
                  <label
                    htmlFor="select-account"
                    className="text-lg font-semibold text-black"
                  >
                    Select Account
                  </label>

                  <div className="relative w-full">
                    <select
                      id="select-loan-type"
                      className="block w-[404px] bg-white border border-gray-300 rounded py-3 pl-4 pr-10 text-base text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                      value={selectedAccount}
                      onChange={(e) => setSelectedAccount(e.target.value)}
                    >
                      <option value="Flash Loan">Flash Loan</option>
                      <option value="Emergency Loan">Emergency Loan</option>
                      <option value="Normal Loan">Normal Loan</option>
                      <option value="Development Loan">Development Loan</option>
                      <option value="Jijenge Loan">Jijenge Loan</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex justify-end pb-4 mt-6">
                <button
                  onClick={() => {
                    handleEligibilityCheck(selectedAccount);
                    setSelectedAccount("Flash Loan");
                  }}
                  className="bg-[#074073] text-white w-[238px] h-[51px] px-6 py-3 rounded-lg text-sm"
                >
                  Check Eligibility
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseLoanType;
